module.exports = __webpack_public_path__ + "img/30.c13e9bfe.jpg";